import React from 'react';

import { isString } from 'lodash';

import { getMessageTemplateKey, useMessageTemplate } from 'hooks';

import Typography, { TypographyProps } from './Typography';

export interface TypographyI18nProps extends Omit<TypographyProps, 'classes'> {}

/**
 * Typography to handle message template keys
 *
 * @example
 * // This will replace they template by the proper value depending on the current language
 * <TypographyI18n variant="h1" color="primary">
 *   %message_template%messages.web.patientLumaBotWelcome
 * </TypographyI18n>
 *
 * // Fallback to normal text
 * <TypographyI18n variant="h1" color="primary">
 *   This will render as normal text inside a Typography
 * </TypographyI18n>
 */
const TypographyI18n: React.FC<TypographyI18nProps> = ({ children, ...rest }) => {
  // Handle message templates
  const templateKey = getMessageTemplateKey(isString(children) ? children : '');
  const templateText = useMessageTemplate(templateKey);

  return <Typography {...rest}>{templateText || children}</Typography>;
};

export default TypographyI18n;
